<!-- 精品果园--简介信息 -->
<template>
<div class="info-block">
  <div class="div-1">
    <div class="info-detail-content" v-html="info.description">
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: 'JpgyInfo2',
  props: {
    info: {
      type: Object,
      default: {}
    }
  },
  data() {
    return {

    }
  },
  created:function(){

  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.info-block .info-block-a{
  display: block;
  position:relative;
  box-sizing:content-box;
  height:100%;
  padding:0px 0px 0px 0px;
  margin:8px;
  background-color: #e6e6e6;
  border:1px solid #e6e6e6;
  background-size: 100px auto;
  background-repeat: no-repeat;
  background-position: 10px center;
  //box-shadow: #bbb 0px 0px 10px;
}

.info-block .info-block-a:hover{
  border:1px solid e6e6e6;
  box-shadow:0px 0px 1px 1px orange;
}

.div-1{
  position:relative;
  height:250px;
  width:100%;
  margin-top:10px;
  padding:10px 10px 10px 10px;
  //background:#fff;
  background-color: #e6e6e6;
  border:1px solid #dddddd;
  border-radius:10px;
  background-color:rgba(255,255,255,0.6);
}

.div-1-1{
  position:relative;
  height:40px;
  font-size:16px;
  font-weight:600;
  text-align:left;
  line-height:40px;
  color:#515151;
}

.div-1-2{
  position:relative;
  height:100%;
  margin-top:20px;
  font-size:12px;
  font-weight:500;
  text-align:left;
  line-height:20px;
  color:#515151;

}

.info-table{
  width:100%;
}

.info-table .td-title{
  width:100px;
  font-size:14px;
  line-height:30px;
  text-align:left;
  text-align: justify;
  text-align-last: justify;
}


.info-table .td-value{
  font-size:14px;
  line-height:30px;
  padding-left:10px;
}

.div-3{
  position:absolute;
  top:0px;
  right:0px;
  height:230px;
  width:140px;
  //background:yellow;
}

.div-3 img{
  width:100px;
  height:100px;
  margin-top:60px
}

.div-3 .td-action-1{
  display:block;
  height:20px;
  width:100px;
  margin-top:5px;
  border:0px solid #000;
  color:#000;
  line-height:20px;
  text-align:center;
}

</style>



// WEBPACK FOOTER //
// src/components/module/JpgyInfo2.vue